<script>
export default {
  // FieldDetacher is a renderless component which is required when a FormField needs to be detached
  // from the wrapping Form component so that it is not considered as a part of a Form and could be
  // configured independently without triggering form logic and without submitting back the input
  // results
  name: 'FieldDetacher',
  provide: {
    formContext: null,
  },
  render() {
    return this.$scopedSlots.default({})
  },
}
</script>
